/**
 * 区分 monthlyChecklistStatus（monthly_checklists.monthly_checklist_status）
 * 出典：02 D-056
 */
export const MONTHLY_CHECKLIST_STATUS_VALUES = ['notStarted', 'inProgress', 'completed'] as const;

export type MonthlyChecklistStatus = (typeof MONTHLY_CHECKLIST_STATUS_VALUES)[number];

export const MONTHLY_CHECKLIST_STATUS_LABELS: Readonly<Record<MonthlyChecklistStatus, string>> = {
  notStarted: '未着手',
  inProgress: '進行中', // 274：旧PCRM の表示名（値は変えない）
  completed: '完了',
};
